module.exports = __webpack_public_path__ + "static/img/scanhh.d3e744dd.png";